import { render } from "./ServicesDetails.vue?vue&type=template&id=aac50644"
import script from "./ServicesDetails.vue?vue&type=script&lang=js"
export * from "./ServicesDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__